import { assetsDashboardsDetailsPageEntryPoint as assetsDashboardsDetailsPageEntryPointSpa } from '@jira/cmdb-assets-dashboards/src/ui/dashboard-details/entrypoint.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServicedeskPageContextResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { assetsDashboardsDetailRoute } from '@atlassian/jira-router-routes-assets-routes/src/assetsDashboardsDetailRoute.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import {
	APP_NAMES,
	toPackageName,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point';

const assetsDashboardsDetailsPageEntryPoint = createChromelessEntryPoint({
	main: assetsDashboardsDetailsPageEntryPointSpa,
});

export const assetsDashboardsDetailRouteEntry = createEntry(assetsDashboardsDetailRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: Spinner,
	entryPoint: () => assetsDashboardsDetailsPageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-assets-dashboards-detail-page',
	resources: [...getAssetsAppResources(), ...getServicedeskPageContextResources()],
	forPaint: [LazyAssetsLayout],
	meta: {
		reporting: {
			id: APP_NAMES.INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE,
			packageName: toPackageName(APP_NAMES.INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE),
			teamName: 'ITSM SAGA',
		},
	},
	bifrost: {
		bifrostGroup: 'shell-only',
		bundling: {
			packageName:
				'@atlassian/jira-router-routes-assets-entries/src/assetsDashboardsDetailRouteEntry.tsx',
			whichExportToUse: 'assetsDashboardsDetailRouteEntry',
		},
		enabled: true,
	},
}));
